import { differenceBy } from 'lodash';
import { useState } from 'react';
import type { Board } from '../interfaces/board';
import { selectAvailableBoards } from '../store/profile/profileSlice';
import { useAppSelector } from './redux';

const useAvailableBoardsForm = () => {
  const availableBoardsRedux = useAppSelector(selectAvailableBoards);
  const [availableBoards, setAvailableBoards] = useState<Board[]>(
    availableBoardsRedux || [],
  );

  const syncAvailableBoards = (selectedBoards: Board[]) => {
    const intersection: any = differenceBy(availableBoardsRedux, selectedBoards, 'id');
    setAvailableBoards(intersection);
  };

  return {
    availableBoards,
    syncAvailableBoards,
  };
};

export default useAvailableBoardsForm;
